import React from 'react';
import { Card, Divider, List, Space, Tag, Typography } from 'antd';

import { HOME_QUOTES } from '../../data/homeQuotes';

const { Title, Text } = Typography;

export default function CorHomeQuotes() {
  return (
    <div style={{ padding: 12 }}>
      <Card>
        <Space direction="vertical" size={8} style={{ width: '100%' }}>
          <Title level={4} style={{ margin: 0 }}>Ana Sayfa Sözleri</Title>
          <Text type="secondary">
            Bu ekranda yalnızca <Text code>HOME_QUOTES</Text> (varsayılan sözler) listelenir.
            Söz ekleme/silme işlemleri için <Text code>frontend/src/data/homeQuotes.ts</Text> dosyasını manuel güncelleyip commit etmelisiniz.
          </Text>
        </Space>

        <Divider />

        <Space direction="vertical" size={12} style={{ width: '100%' }}>
          <div>
            <Space size={8} wrap>
              <Text strong>Varsayılan sözler</Text>
              <Tag>{HOME_QUOTES.length}</Tag>
            </Space>
            <List
              size="small"
              bordered
              dataSource={HOME_QUOTES}
              style={{ marginTop: 8 }}
              renderItem={(q) => (
                <List.Item>
                  <Space size={8}>
                    <Tag>Varsayılan</Tag>
                    <Text>{q}</Text>
                  </Space>
                </List.Item>
              )}
            />
          </div>
        </Space>
      </Card>
    </div>
  );
}

